(function () {
  function copies(n, id) {
    const out = [];
    for (let i = 0; i < n; i++) out.push(id);
    return out;
  }

  const DARIUS_DECK = [].concat(
    copies(3, "ogn-010-298"),
    copies(3, "ogn-001-298"),
    copies(3, "ogn-013-298"),
    copies(3, "ogn-009-298"),
    copies(3, "ogn-004-298"),
    copies(3, "ogn-005-298"),
    copies(3, "ogn-012-298"),
    copies(3, "ogn-210-298"),
    copies(3, "ogn-215-298"),
    copies(3, "ogn-219-298"),
    copies(3, "ogn-217-298"),
    copies(3, "ogn-206-298"),
    copies(2, "ogn-027-298"),
    copies(1, "ogn-254-298")
  );

  const LEONA_DECK = [].concat(
    copies(3, "ogn-052-298"),
    copies(3, "ogn-054-298"),
    copies(3, "ogn-049-298"),
    copies(3, "ogn-050-298"),
    copies(3, "ogn-051-298"),
    copies(3, "ogn-055-298"),
    copies(3, "ogn-210-298"),
    copies(3, "ogn-215-298"),
    copies(3, "ogn-219-298"),
    copies(3, "ogn-211-298"),
    copies(3, "ogn-206-298"),
    copies(2, "ogn-238-298"),
    copies(1, "ogn-262-298")
  );

  window.RB = window.RB || {};
  window.RB.DEMO_SETUP = {
    seed: 42,
    firstPlayer: 0,
    players: [
      {
        name: "Darius",
        legend: "ogn-253-298",
        champion: "ogn-027-298",
        deck: DARIUS_DECK,
        runes: [].concat(copies(6, "Fury Rune"), copies(6, "Order Rune")),
        battlefields: ["ogn-275-298"],
      },
      {
        name: "Leona",
        legend: "ogn-261-298",
        champion: "ogn-238-298",
        deck: LEONA_DECK,
        runes: [].concat(copies(6, "Calm Rune"), copies(6, "Order Rune")),
        battlefields: ["ogn-280-298"],
      },
    ],
  };
})();
